<template>
  <div class="page-wrapper">
    <div class="page-container">
      <PageHeader title="定制茶信息详情" @back="goBack" />

      <div class="content-area">
        <!-- 基本信息 -->
        <PrescriptionCard title="基本信息">
          <div class="info-grid" v-if="consultInfo">
            <div class="info-item">
              <span class="info-label">姓名：</span>
              <span class="info-value">{{ consultInfo.name }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">性别：</span>
              <span class="info-value">{{ consultInfo.sex == '1' ? '男' : '女' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">电话：</span>
              <span class="info-value">{{ consultInfo.phoneNo }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">出生日期：</span>
              <span class="info-value">{{ consultInfo.birthday }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">常住地址：</span>
              <span class="info-value">{{ consultInfo.liveArea }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">出生地址：</span>
              <span class="info-value">{{ consultInfo.birthArea }}</span>
            </div>
            <div class="info-item" v-if="consultInfo.useDate">
              <span class="info-label">开始服药时间：</span>
              <span class="info-value">{{ consultInfo.useDate }}</span>
            </div>
            <div class="info-item" v-if="consultInfo.useDays">
              <span class="info-label">服药天数：</span>
              <span class="info-value">{{ consultInfo.useDays }}</span>
            </div>
          </div>
        </PrescriptionCard>

        <!-- 商品信息 -->
        <PrescriptionCard title="商品信息">
          <div class="info-item">
            <span class="info-label">商品：</span>
            <span class="info-value">私人定制茶一份</span>
          </div>
        </PrescriptionCard>

        <!-- 查询信息 -->
        <PrescriptionCard title="查询信息">
          <div class="query-list" v-if="resultsZJYC.length > 0">
            <div class="query-item">
              <p
                class="query-line"
                v-for="(item, index) in resultsZJYC"
                :key="index"
              >
                {{ item }}
              </p>
            </div>
          </div>
        </PrescriptionCard>

        <!-- 按钮区 -->
        <div class="btn-area">
          <el-button
            v-if="consultInfo.deliveryMark == 1"
            class="btn-submit"
            type="primary"
            @click="submit"
          >统一配送</el-button>
          <el-button
            v-else-if="consultInfo.deliveryMark == 2"
            class="btn-submit"
            type="primary"
            @click="psxq"
          >配送详情</el-button>
        </div>
      </div>
    </div>

    <!-- 更换药方弹窗 -->
    <el-dialog
      title="更换药方"
      :visible.sync="dialogDrugVisible"
      center
      destroy-on-close
      width="20%"
    >
      <div class="item-column">
        <el-radio
          class="radio"
          v-for="drug in changeDrugList"
          v-model="currentDrug"
          :label="drug"
          :key="drug"
        >{{ drug }}</el-radio>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDrugVisible = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm" size="medium">修 改</el-button>
      </div>
    </el-dialog>

    <!-- 更换重量弹窗 -->
    <el-dialog
      title="更换重量"
      :visible.sync="dialogWeightVisible"
      center
      destroy-on-close
      width="20%"
    >
      <div class="item-row">
        <span style="width: 30%">{{ flag == 0 ? currentItem.key : currentItem.key1 }}</span>
        <el-input-number
          v-model="currentWeight"
          @change="numberChange"
          :min="1"
          :max="999"
          :label="flag == 0 ? currentItem.key : currentItem.key1"
          size="small"
        ></el-input-number>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogWeightVisible = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="dialogWeightConfirm" size="medium">修 改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from "@/components/widgets/PageHeader.vue";
import PrescriptionCard from "@/components/smallComponents/PrescriptionCard.vue";

export default {
  components: {
    PageHeader,
    PrescriptionCard,
  },
  data() {
    return {
      tabActive: "0",
      prescriptions: [],
      tablePrescription: [],
      changeDrugList: [],
      visible: false,
      dialogDrugVisible: false,
      dialogWeightVisible: false,
      currentDrug: "",
      currentWeight: "",
      currentItem: {},
      flag: 0,
      basicTableArray: [],
      shangjiaoTableArray: [],
      zhongjiaoTableArray: [],
      xiajiaoTableArray: [],
      consultInfo: {},
      radio1: "开方信息",
      resultsZJYC: "",
      resultsJKYC: "",
      resultsTYF: "",
    };
  },
  created() {
    this.visitRecordId = this.$route.query.visitRecordId;
    this.patientId = this.$route.query.patientId;
    this.wjtHttp.post(
      this,
      "/api/health/v2/customTeaInfo",
      { visitRecordId: this.visitRecordId },
      false,
      (res) => {
        var data = res.data;
        if (data.code == 200) {
          this.prescriptions = data.data.prescriptionInfos;
          this.consultInfo = data.data.patient;
          this.consultInfo.useDate = data.data.startDate;
          this.consultInfo.useDays = data.data.takeDays;
          this.consultInfo.deliveryMark = data.data.deliveryMark;
          this.consultInfo.deliveryOrderId = data.data.deliveryOrderId;

          var rs = data.data.customTeaResult.split("\n");
          var newRS = [];
          rs.forEach((val, index) => {
            if (val.length != 0) {
              newRS.push(val.replace(/ /g, ""));
            }
          });
          this.resultsZJYC = newRS;

          this.generateTableData();
        } else {
          this.$message({
            message:
              data.msg && data.msg.length > 0
                ? data.msg
                : "出方异常，请联系管理员",
            type: "error",
          });
        }
      },
      (err) => {
        console.log(err);
      }
    );
  },
  methods: {
    changeType(e) {
      console.log(e);
      if (e == "针灸信息" && this.resultsZJYC === "") {
        this.getrecord("A");
      } else if (e == "健康指引信息" && this.resultsJKYC === "") {
        this.getrecord("D");
      } else if (e == "通用方信息" && this.resultsTYF === "") {
        this.getrecord("G");
      }
    },
    getrecord(e) {
      this.wjtHttp.post(
        this,
        "/api/health/v2/rela/record",
        {
          relaVisitRecordId: this.visitRecordId,
          patientId: this.patientId,
          recordType: e,
          toDoDay: this.consultInfo.useDate,
          takeDays: this.consultInfo.useDays,
        },
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            if (this.radio1 == "通用方信息") {
              this.resultsTYF = data.data.prescriptionInfos;
              this.generateTableData2();
              return;
            }
            var rs = data.data.split("\n");
            var newRS = [];
            rs.forEach((val, index) => {
              if (val.length != 0) {
                newRS.push(val.replace(/ /g, ""));
              }
            });
            if (this.radio1 == "针灸信息") {
              this.resultsZJYC = newRS;
            } else if (this.radio1 == "健康指引信息") {
              this.resultsJKYC = newRS;
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "出方异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    goBack() {
      this.$router.go(-1);
    },
    submit() {
      sessionStorage.setItem("consultInfo", JSON.stringify(this.consultInfo));
      this.$router.push({
        path: "/CUSTOMIZEDfulfillmentConfirm",
        query: {
          visitRecordId: this.visitRecordId,
          index: 1,
        },
      });
    },
    psxq() {
      this.$router.push({
        path: "/CUSTOMIZEDfulfillmentOrder",
        query: {
          orderId: this.consultInfo.deliveryOrderId,
        },
      });
    },
    generateTableData() {
      this.tablePrescription = [];
      for (var i = 0; i < this.prescriptions.length; i++) {
        var table_data_item = {};
        var item = this.prescriptions[i];
        table_data_item.count = item.count;
        table_data_item.charge = item.charge;
        table_data_item.totalWeight = item.totalWeight;
        table_data_item.startDate = item.startDate;
        table_data_item.endDate = item.endDate;
        table_data_item.title = item.name;

        var itemArray = item.prescription;
        for (var j = 0; j < item.prescription.length; j++) {
          var itemJ = item.prescription[j];
          if (j % 2 == 1) {
            itemArray[j - 1].key1 = itemJ.key;
            itemArray[j - 1].value1 = itemJ.value;
            itemArray[j - 1].index1 = itemJ.index;
            itemArray[j - 1].visible1 = false;
          } else {
            itemArray[j].visible = false;
          }
        }
        var options = [];
        for (var k = 0; k < itemArray.length; k++) {
          if (k % 2 == 0) {
            options.push(itemArray[k]);
          }
        }
        table_data_item.options = options;
        this.tablePrescription.push(table_data_item);
      }
    },
    drugChangeClick(item, flag) {
      this.currentItem = item;
      this.flag = flag;
      var params = {
        patientId: this.patientId,
        visitRecordId: this.visitRecordId,
        medicineName: flag == 0 ? item.key : item.key1,
        number: parseInt(this.tabActive) + 1,
      };
      this.wjtHttp.post(
        this,
        "/api/health/v1/prescription/replace",
        params,
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            if (!this.utils.isEmptyStr(data.data.replaceMedicines)) {
              this.changeDrugList = data.data.replaceMedicines;
              this.currentDrug = "";
              this.dialogDrugVisible = true;
            } else {
              this.$message({
                message: "无可更换药品",
                type: "info",
              });
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0 ? data.msg : "无可更换药品",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    dialogConfirm() {
      if (this.utils.isEmptyStr(this.currentDrug)) {
        this.$message({
          message: "请选择需要更换的药材",
          type: "info",
        });
        return;
      }
      this.dialogDrugVisible = false;
      var params = {
        visitRecordId: this.visitRecordId,
        oldMedicineName:
          this.flag == 0 ? this.currentItem.key : this.currentItem.key1,
        replaceMedicineName: this.currentDrug,
        oldWeight:
          this.flag == 0 ? this.currentItem.value : this.currentItem.value1,
        replaceWeight:
          this.flag == 0 ? this.currentItem.value : this.currentItem.value1,
        number: parseInt(this.tabActive) + 1,
      };
      this.wjtHttp.post(
        this,
        "/api/health/v1/prescription/replace/submit",
        params,
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.wjtHttp.post(
              this,
              "/api/health/v1/prescription",
              { visitRecordId: this.visitRecordId },
              false,
              (res) => {
                var data = res.data;
                if (data.code == 200) {
                  this.prescriptions = data.data;
                  this.generateTableData();
                } else {
                  this.$message({
                    message:
                      data.msg && data.msg.length > 0
                        ? data.msg
                        : "出方异常，请联系管理员",
                    type: "error",
                  });
                }
              },
              (err) => {
                console.log(err);
              }
            );
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0 ? data.msg : "更换药材失败",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    drugWeightClick(item, flag) {
      this.currentItem = item;
      this.flag = flag;
      this.currentWeight = this.flag == 0 ? item.value : item.value1;
      this.dialogWeightVisible = true;
    },
    dialogWeightConfirm() {
      this.dialogWeightVisible = false;
      var params = {
        visitRecordId: this.visitRecordId,
        oldMedicineName:
          this.flag == 0 ? this.currentItem.key : this.currentItem.key1,
        replaceMedicineName:
          this.flag == 0 ? this.currentItem.key : this.currentItem.key1,
        oldWeight:
          this.flag == 0 ? this.currentItem.value : this.currentItem.value1,
        replaceWeight: this.currentWeight,
        number: parseInt(this.tabActive) + 1,
      };
      this.wjtHttp.post(
        this,
        "/api/health/v1/prescription/replace/submit",
        params,
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.wjtHttp.post(
              this,
              "/api/health/v1/prescription",
              { visitRecordId: this.visitRecordId },
              false,
              (res) => {
                var data = res.data;
                if (data.code == 200) {
                  this.prescriptions = data.data;
                  this.generateTableData();
                } else {
                  this.$message({
                    message:
                      data.msg && data.msg.length > 0
                        ? data.msg
                        : "修改重量异常，请联系管理员",
                    type: "error",
                  });
                }
              },
              (err) => {
                console.log(err);
              }
            );
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "修改重量异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    numberChange(value) {
      this.currentItem.newValue = value;
    },
  },
};
</script>

<style scoped>
.changeGroup .el-radio-button__inner {
  width: auto !important;
  height: auto !important;
}
</style>

<style scoped>
/* ============================================================
   CUSTOMIZED Prescription — 绿色卡片主题（同步 PrescriptionResultPage）
   ============================================================ */

.page-wrapper {
  min-height: 100vh;
  background: #fbfcfa;
}

.page-container {
  max-width: 1152px;
  margin: 0 auto;
  padding: 32px 24px 80px;
}

/* 内容区域 */
.content-area {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 信息网格 */
.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.info-item {
  display: flex;
  align-items: center;
  border: 1px solid #edf0ec;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 18px;
  line-height: 1.5;
}

.info-label {
  color: #555;
  flex-shrink: 0;
  min-width: 120px;
  font-size: 18px;
}

.info-value {
  color: #1a1a1a;
  font-weight: 500;
  font-size: 16px;
  word-break: break-all;
}

/* 查询信息列表 */
.query-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.query-item {
  border: 1px solid #edf0ec;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 16px;
  color: #1a1a1a;
  line-height: 1.6;
}

.query-line {
  margin: 0;
  padding: 2px 0;
  line-height: 1.8;
}

/* 按钮区域 */
.btn-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-top: 12px;
}

.btn-submit {
  width: 100%;
  max-width: 680px;
  height: 56px;
  border-radius: 12px;
  background: #009798;
  border: none;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  box-shadow: 0 8px 20px rgba(0, 151, 152, 0.25);
  transition: all 0.2s;
}

.btn-submit:hover {
  background: #007e7f !important;
  box-shadow: 0 12px 28px rgba(0, 151, 152, 0.35);
}

.btn-submit:active {
  background: #007e7f !important;
}

/* ── 弹窗内部样式（保留） ── */
.item-row {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.item-column {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.radio {
  width: 100%;
  margin-bottom: 20px;
  margin-left: 0px;
  margin-right: 0px;
}

/* ── 响应式 ── */
@media (max-width: 768px) {
  .page-container {
    padding: 20px 16px 60px;
  }

  .content-area {
    gap: 20px;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }
}
</style>
